import { User, type SystemRole } from "@/models"
import { SARLogHttpService } from "@/services/httpService"
import { urlWithParams } from "vue-utils"

export interface GetUsersOptions {
	role?: SystemRole
}

export class UsersService extends SARLogHttpService {
	constructor() {
		super("/api/users")
	}

	async getAll(options: GetUsersOptions = {}): Promise<User[]> {
		return await this.returning(User.Schema.array()).get(urlWithParams("", options))
	}

	async getLoggedIn(): Promise<User> {
		return await this.returning(User.Schema).get("logged-in")
	}
}
